import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { formatearFecha } from '../../helpers/dateValidation'
import InputLabel from '../ui/InputLabel'
import styles from './Ofertas.module.css'

const FORMATO_INPUT_DATE = 'YYYY-MM-DD'

const Ofertas = ({ values, onChange, vieneDeAdministrar }) => {
  const inicializado = useRef(false)
  useEffect(() => {
    if (
      !inicializado.current &&
      vieneDeAdministrar &&
      Number(values.porcDctoPublicacion) > 0 &&
      (values.porcDcto === undefined || values.porcDcto === null)
    ) {
      onChange(
        {
          target: { name: 'porcDcto', value: values.porcDctoPublicacion, type: 'number' }
        },
        'num'
      )
      inicializado.current = true
    }
  }, [vieneDeAdministrar, values.porcDctoPublicacion, values.porcDcto, onChange])

  function fechaLegible(fecha) {
    if (!fecha || fecha === '0001-01-01T00:00:00' || fecha === '0001-01-01' || fecha === null) {
      return ''
    }
    if (fecha.includes('T')) {
      return fecha.split('T')[0].split('-').reverse().join('/')
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      return fecha.split('-').reverse().join('/')
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
      return fecha
    }
    return fecha
  }

  const precioFinal =
    !isNaN(Number(values.porcDcto)) && !isNaN(Number(values.precioUnitario))
      ? Number(values.porcDcto) === 0
        ? Number(values.precioUnitario)
        : Number(values.precioUnitario) -
          (Number(values.porcDcto) * Number(values.precioUnitario)) / 100
      : ''

  function estaEnVigencia(desde, hasta) {
    if (!desde || !hasta) {
      return false
    }
    const hoy = new Date()
    const d = new Date(desde)
    const h = new Date(hasta)
    return d <= hoy && hoy <= h
  }

  const porcDctoPublicacion = Number(values.porcDctoPublicacion) || 0
  const porcDctoLista = Number(values.porcDctoLista) || 0
  const ofertaDesde = values.ofertaDesde || ''
  const ofertaHasta = values.ofertaHasta || ''

  const vigenciaDesde = formatearFecha(values.vigenciaDesde, FORMATO_INPUT_DATE)
  const vigenciaHasta = formatearFecha(values.vigenciaHasta, FORMATO_INPUT_DATE)
  const ofertaDesdeInput = formatearFecha(values.ofertaDesde, FORMATO_INPUT_DATE)
  const ofertaHastaInput = formatearFecha(values.ofertaHasta, FORMATO_INPUT_DATE)
  const listaOfertaDesde = values.listaOfertaDesde || ''
  const listaOfertaHasta = values.listaOfertaHasta || ''

  let origen = 'Sin descuento'
  let vigencia = ''
  let porcentaje = ''
  let mostrar = false

  if (porcDctoPublicacion > 0 && estaEnVigencia(ofertaDesde, ofertaHasta)) {
    origen = 'Descuento de publicación'
    porcentaje = `${porcDctoPublicacion}%`
    vigencia =
      ofertaDesde && ofertaHasta
        ? `Vigente del ${fechaLegible(ofertaDesde)} al ${fechaLegible(ofertaHasta)}`
        : ''
    mostrar = true
  } else if (porcDctoLista > 0 && estaEnVigencia(listaOfertaDesde, listaOfertaHasta)) {
    origen = 'Descuento de lista'
    porcentaje = `${porcDctoLista}%`
    vigencia =
      listaOfertaDesde && listaOfertaHasta
        ? `Vigente del ${fechaLegible(listaOfertaDesde)} al ${fechaLegible(listaOfertaHasta)}`
        : ''
    mostrar = true
  } else {
    origen = 'Sin descuento'
    porcentaje = ''
    vigencia = ''
    mostrar = true
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className={styles.descripcionCuadroPublicacion}>
          Aquí puede incluir una oferta de tiempo limitado para su producto. Las fechas de Inicio y
          finalización son únicamente válidas para la oferta realizada.
        </p>
      )}
      <div className={`${styles.ofertasContainer} ${styles.gapInputs}`}>
        <div className={styles.fieldGroup}>
          <span className={styles.fieldLabel}>Porcentaje de Descuento:</span>
          <div className={styles.flexInput}>
            <InputLabel
              type="number"
              name="porcDcto"
              value={
                values.porcDcto === undefined || values.porcDcto === null ? '' : values.porcDcto
              }
              onChange={(e) => onChange(e, 'num')}
              onFocusSelected
              classNameInput={styles.inputOferta}
              classNameContainer={styles.flexInput}
            />
            <i className={`fa fa-percent ${styles.iconoPorcentaje}`} aria-hidden="true" />
          </div>
        </div>
        <div className={styles.fieldGroup}>
          <span className={styles.fieldLabel}>Precio final de Publicación (SIN IVA):</span>
          <div className={styles.precioFinalRow}>
            <i className={`fa fa-usd ${styles.iconoPrecio}`} aria-hidden="true" />
            <InputLabel
              name="precioFinal"
              value={precioFinal}
              readOnly
              classNameInput="input-text-bordered w-40"
            />
          </div>
        </div>
        <div className={styles.fieldGroup}>
          <InputLabel
            type="date"
            name="ofertaDesde"
            classNameInput={styles.inputOferta}
            value={ofertaDesdeInput || ''}
            onChange={onChange}
            label="Fecha de Inicio: "
            error="Completar Fecha de Inicio Oferta"
            classNameContainer={styles.flexInput}
            min={vigenciaDesde || undefined}
            max={ofertaHastaInput || vigenciaHasta || undefined}
          />
        </div>
        <div className={styles.fieldGroup}>
          <InputLabel
            type="date"
            name="ofertaHasta"
            classNameInput={styles.inputOferta}
            value={ofertaHastaInput || ''}
            onChange={onChange}
            label="Fecha de Finalización: "
            error="Completar Fecha de Finalización Oferta"
            classNameContainer={styles.flexInput}
            min={ofertaDesdeInput || vigenciaDesde || undefined}
            max={vigenciaHasta || undefined}
          />
        </div>
      </div>
      {mostrar && (
        <div className={styles.infoCard}>
          <div>
            <b>Descuento aplicado:</b> {porcentaje || 'Sin descuento'}
          </div>
          {vigencia && (
            <div>
              <b>Vigencia:</b> {vigencia}
            </div>
          )}
          <div>
            <b>Origen:</b> {origen}
          </div>
        </div>
      )}
    </>
  )
}

Ofertas.propTypes = {
  values: PropTypes.shape({
    porcDcto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    porcDctoPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    porcDctoLista: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    listaVigenciaHasta: PropTypes.string,
    listaVigenciaDesde: PropTypes.string,
    vigenciaDesde: PropTypes.string,
    vigenciaHasta: PropTypes.string,
    listaOfertaDesde: PropTypes.string,
    listaOfertaHasta: PropTypes.string,
    precioUnitario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    ofertaDesde: PropTypes.string.isRequired,
    ofertaHasta: PropTypes.string.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default Ofertas
